import { render } from "./LoginOrCreateModal.vue?vue&type=template&id=0c250a10&ts=true&lang=pug"
import script from "./LoginOrCreateModal.vue?vue&type=script&setup=true&lang=ts"
export * from "./LoginOrCreateModal.vue?vue&type=script&setup=true&lang=ts"

import "./LoginOrCreateModal.vue?vue&type=style&index=0&id=0c250a10&lang=scss"

import exportComponent from "/codebuild/output/src2191176947/src/lottrackr-front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__